jQuery(document).ready(function($) {

	// Headroom
	var header = document.querySelector(".page-header");
	var headroom  = new Headroom(header);
	headroom.init();

	// Nav
	$menuLeft = $('.pushmenu-left');
	$nav_list = $('.hamburger');

	$nav_list.click(function() {
		$(this).toggleClass('is-active');
		$('body').toggleClass('nav-open');
		$('.page-wrap').toggleClass('pushmenu-push-toright');
		$menuLeft.toggleClass('pushmenu-open');
	});

	// handle links with @href started with '#' only
	// $(document).on('click', 'a[href^="#"]', function(e) {
	// 	// target element id
	// 	var id = $(this).attr('href');

	// 	// target element
	// 	var $id = $(id);
	// 	if ($id.length === 0) {
	// 		return;
	// 	}

	// 	// prevent standard hash navigation (avoid blinking in IE)
	// 	e.preventDefault();

	// 	// top position relative to the document
	// 	var pos = $id.offset().top;

	// 	// animated top scrolling
	// 	$('body, html').animate({scrollTop: pos}, 500);
	// });

	// FAQ
	if ($('.faq-container').length > 0) {
		$('.faq .faq__question').click(function() {
			$('.faq .faq__question').removeClass('active');
			$('.faq .faq__answer').slideUp('normal');
			if($(this).next().is(':hidden') == true) {
				$(this).addClass('active');
				$(this).next().slideDown('normal');
			}
			return false;
		});
		$('.faq .faq__answer').hide();
	}

	// Products page filter
	function filterbyid() {
		// If page URL has an ID, use it to show products
		if((window.location.hash != '') && (window.location.hash != '#download') && (window.location.hash != '#order') && (window.location.hash != '#menu') ){
			var id = window.location.hash.substring(1);
			$('.gallery-item').hide();
			$('.'+id).show();
			$('#filter a').removeClass('active');
			$('a[rel="' + id + '"]').addClass("active");
		} else {
			$('.breads').show();
			$('a[rel="breads"]').addClass("active");
		}
	}
	filterbyid();

	window.onhashchange = function() {
		filterbyid();
		// console.log(window.location.hash);
	};

	// Filter functionality
	$('#filter a').click(function() {
		$('#filter a').removeClass('active');
		$(this).addClass('active');

		if($(this).attr('rel')) {
			var category = $(this).attr('rel');
			$('.gallery-item').fadeOut(300, function() {
				$(this).filter('[class="gallery-item ' + category  + '"]').delay(300).fadeIn(300);
			});
		} else {
			$('.gallery-item').fadeIn(300);
		}

		return false;
	});

	// Menu
	$('.menu-nav a').click(function() {
		var category = $(this).attr('rel');

		$('.menu-nav a').removeClass('active');
		$(this).addClass('active');

		if($(this).attr('rel')) {
			$('.menu').fadeOut(300, function() {
				$(this).filter('[class="menu ' + category  + '"]').delay(300).fadeIn(300);
			});
		} else {
			$('.menu').fadeIn(300);
		}

		return false;
	});

    function loadmenubyhash() {
        if((window.location.hash == '#specials') ){
            $('.menu-nav a').removeClass('active');
            $('.menu-nav a[rel="specials"]').addClass('active') ;
            $('.dine-in').hide();
            $('.specials').show();
        } else if((window.location.hash == '#dine-in') ){
            $('.menu-nav a').removeClass('active');
            $('.menu-nav a[rel="dine-in"]').addClass('active') ;
            $('.specials').hide();
            $('.dine-in').show();
        } else {
            $('.dine-in').show();
            $('.menu-nav a[rel="dine-in"]').addClass('active') ;
        }
	}
	loadmenubyhash();

	window.onhashchange = function() {
		loadmenubyhash();
		// console.log(window.location.hash);
	};

	// Show/hide logo on home page
	$(window).scroll( function(){
		var height = $(window).height();
		var scroll_pos = $(window).scrollTop();

		if( scroll_pos > height ){
			$(".nav-bar--home .logo-text, .nav-bar--home .logo-flourish").addClass('logo--show').removeClass('logo--hide');

		} else {
			$(".nav-bar--home .logo-text, .nav-bar--home .logo-flourish").addClass('logo--hide').removeClass('logo--show');
		}
	});

	// Show hovers on iPad
	$(".gallery-item, .gallery__item").hover(
		function() {
			$(this).children().css({ 'display': "flex" });
		}, function() {
			$(this).children().css({ 'display': "none" });
		}
	);

	// Single Product Readmore
	var short_desc = '.woocommerce-product-details__short-description';
	$(short_desc).hide();
    $(".show-hide").on("click", function () {
        var txt = $(short_desc).is(':visible') ? 'Read More' : 'Read Less';
        $(".show-hide").text(txt);
        $(this).prev(short_desc).slideToggle(200);
    });
	
	// Category filter
	$("select.category-select").change(function(){
		var slug = $(this).children("option:selected").val();
		var categoryUrl = '/' + slug;
		if (categoryUrl) {
			window.location = categoryUrl;
		}
		return false;
    });

    // Modal
    // if ($("#modal")[0]){
    //     $.featherlight('#modal');
    // }
});
